import api from '@/api'

const SET_SCHEDULES = 'SET_SCHEDULES'
const SET_CURRENT_SCHEDULE = 'SET_CURRENT_SCHEDULE'
const UNSET_CURRENT_SCHEDULE = 'UNSET_CURRENT_SCHEDULE'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      schedules: [],
      currentSchedule: null
    }
  },

  getters: {
    schedules: (state) => state.schedules,
    currentSchedule: (state) => state.currentSchedule,
    filters: (state) => state.filters
  },

  mutations: {
    [SET_SCHEDULES] (state, data) {
      state.schedules = data
    },

    [SET_CURRENT_SCHEDULE] (state, data) {
      state.currentSchedule = data
    },

    [UNSET_CURRENT_SCHEDULE] (state) {
      state.currentSchedule = null
    }
  },

  actions: {
    async loadSchedules ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.schedule.list(filters)
      commit(SET_SCHEDULES, data || [])
    },

    async createSchedule ({ dispatch, getters }, payload) {
      const filters = getters.filters
      await api.schedule.create(payload)
      dispatch('loadSchedules', filters)
    },

    async sortSchedules ({ dispatch }, payload) {
      await api.schedule.createByOrder(payload)
    },

    async getSchedule ({ commit }, id) {
      const { data } = await api.schedule.getById(id)
      commit(SET_CURRENT_SCHEDULE, data)
    },

    async updateSchedule ({ commit, dispatch, getters }) {
      const item = getters.currentSchedule
      const filters = getters.filters
      await api.schedule.updateById(item.id, item)
      dispatch('loadSchedules', filters)
      commit(UNSET_CURRENT_SCHEDULE)
    },

    async deleteSchedule ({ commit, dispatch, getters }) {
      const item = getters.currentSchedule
      const filters = getters.filters
      await api.schedule.deleteById(item.id)
      dispatch('loadSchedules', filters)
      commit(UNSET_CURRENT_SCHEDULE)
    },

    closeSchedule ({ commit }) {
      commit(UNSET_CURRENT_SCHEDULE)
    }
  }
}
